export default __webpack_public_path__ + "static/media/instagram.5617d7ca.svg";